import { useSelector } from "react-redux"
import { useNavigate, useLocation } from "react-router"
import Button from "react-bootstrap/Button"
import "./index.scss"
import { ScheduleButtons } from "components"
import { limsCapabilities } from "state_management"
import useT from "utils/hooks/useT"

function NavItem({ url, children }) {
  const location = useLocation()
  const navigate = useNavigate()

  return (
    <Button variant={location.pathname.startsWith(url) ? "primary" : "light"} onClick={() => navigate(url)}>
      {children}
    </Button>
  )
}

export default function AdminHeader() {
  const location = useLocation()
  const showProjects = useSelector((state) => state.teamStatus.showProjects)
  const showAnalyses = useSelector((state) => state.teamStatus.showAnalyses)
  const isMember = useSelector((state) => state.auth.isMember)
  // SPEC-057 L1: a qa-manager holder (MEMBER planning role, LIMS team) gets the header with
  // just the team tab, so they can staff the quality column.
  const isLimsQaManager = useSelector(limsCapabilities.selectIsLimsQaManager)
  const teamName = useSelector((state) => state.teamInfo.teamName)
  const teamLocation = useSelector((state) => state.teamInfo.location)
  const creatingOrEditingProject = location.pathname.includes("/setup/projects/")
  const { t } = useT("common")

  return (
    <>
      <ScheduleButtons type="settings-view" />
      {(!isMember || isLimsQaManager) && !creatingOrEditingProject && (
        <div className="AdminHeader">
          <div className="TeamLocation">
            <p>{t("teamLabel", { name: teamName })}</p>
            <p>{t("locationColon", { name: teamLocation })}</p>
          </div>
          <div className="AdminHeader-nav">
            {/* SPEC-057 L1: a qa-manager holder with the MEMBER planning role sees ONLY the
                team tab — the quality column staffs itself, nothing more. */}
            {<NavItem url="/setup/members">{t("team")}</NavItem>}
            {!isMember && <NavItem url="/setup/assets">{t("instruments")}</NavItem>}
            {!isMember && (showProjects || showAnalyses) && <NavItem url="/setup/competence-groups">{t("competenceGroups")}</NavItem>}
            {showAnalyses && !isMember && <NavItem url="/setup/analyses">{t("analyses")}</NavItem>}
            {showProjects && !isMember && <NavItem url="/setup/project-templates">{t("projectTemplates")}</NavItem>}
            {!isMember && <NavItem url="/setup/integration">{t("integration")}</NavItem>}
            {!isMember && <NavItem url="/setup/advanced">{t("advanced")}</NavItem>}
          </div>
        </div>
      )}
    </>
  )
}
